import { render } from "./single-picture.vue?vue&type=template&id=20de30ea&scoped=true"
import script from "./single-picture.vue?vue&type=script&lang=js"
export * from "./single-picture.vue?vue&type=script&lang=js"

import "./single-picture.vue?vue&type=style&index=0&id=20de30ea&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-20de30ea"]])

export default __exports__